<template>
  <!-- Importing Home Component -->
  <HomeComp></HomeComp>
</template>
<script>
import HomeComp from "../components/Home.vue";

export default {
  name: "Home",
  components: { HomeComp },
  computed: {},
  mounted() {},
};
</script>
